import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

/**
 * The ProtectByOrgCode's component.
 */
const ProtectByOrgCode = props => {
  const { children, redirectTo, validOrgCode } = props
  const navigate = useNavigate()

  if (validOrgCode) {
    navigate(redirectTo)
  }

  return <>{children}</>
}

ProtectByOrgCode.defaultProps = {
  validOrgCode: true,
  redirectTo: ''
}

ProtectByOrgCode.propTypes = {
  children: PropTypes.node.isRequired,
  validOrgCode: PropTypes.bool,
  redirectTo: PropTypes.string
}

export default ProtectByOrgCode
